import { render, staticRenderFns } from "./RateListEdit.vue?vue&type=template&id=36ad8b35&"
import script from "./RateListEdit.vue?vue&type=script&lang=js&"
export * from "./RateListEdit.vue?vue&type=script&lang=js&"
import style0 from "./RateListEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports